'use client'

import { Container } from 'react-bootstrap'
import NavigationList from '@/entities/NavigationList'
import './Footer.css'
import { useEffect, useState } from 'react'
import { useAboutTextMutation } from '@/shared/api-rtk/index.js'
import { links, links2 } from '../consts/links'

export function Footer() {
    const [aboutText, setAboutText] = useState('')
    const [getText] = useAboutTextMutation()

    useEffect(() => {
        getText(2)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setAboutText(res.data.value)
                }
            })
    }, [])

    return (
        <div className={'FooterMain'}>
            <Container>
                <NavigationList navigationLinks={links} navigationLinks2={links2} />
                <div className={'seporator'}></div>
                <div
                    className={'footerDescription'}
                    style={{ textAlign: 'center' }}
                >
                    {aboutText && aboutText}
                    {!aboutText && `Текст внизу`}
                </div>
            </Container>
        </div>
    )
}
